import FlexiButton from "slotworks/graphics/elements/flexi-button";
import Layers from "slotworks/graphics/layers/layers";
import AbstractButtonBehaviour from "slotworks/smart-button/behaviours/abstract-button-behaviour";
import autoplayModel from "slotworks/model/autoplay-model";

export default class HiddenButtonBehaviour extends AbstractButtonBehaviour {

    private autoButton: FlexiButton;

    public init() {
        Layers.SmartButton.defaultScene().execute();

        this.button = Layers.SmartButton.getFlexiButton("spin");
        this.autoButton = Layers.SmartButton.getFlexiButton("auto_start");

        if (this.button) {
            this.button.setVisible(false);
        }
        if (this.autoButton) {
            this.autoButton.setVisible(false);
        }
    }

    public destroy() {
        if (this.button) {
            this.button.setVisible(true);
        }
        if (this.autoButton  && !autoplayModel.autoplayDisabled) {
            this.autoButton.setVisible(true);
        }
        super.destroy();
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/smart-button/behaviours/hidden-button-behaviour.ts